import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router";
import { PARTNERS_QUERIES } from "~/shared/api/partners/partners.queries";
import { notFound } from "~/shared/util/notFound";

export async function companyLoader(args: LoaderFunctionArgs, queryClient: QueryClient) {
  const { params } = args;
  const { partnerId } = params;

  if (!partnerId) {
    return notFound();
  }

  queryClient.ensureQueryData(PARTNERS_QUERIES.detail(partnerId));

  return null;
}
